import callAPI from "../../commonservices/APIRequests"
import { setSharedNotes, setSharedNotesLoader } from "../Reducers/Notes"

export const getSharedNotes = (id, notesType, vehicleId, auditDetails = null, isTitleInventory = false) => {
    return dispatch => {

        dispatch(setSharedNotesLoader(true));
        const req = {
            type: notesType,
            count: true,
            vehicleId: vehicleId
        }

        if (notesType === 'Supplier Note') {
            req.supplierId = id
        } else {
            req.dealerId = id
        }

        if (auditDetails) {
            req.auditType = auditDetails.auditType;
            req.auditId = auditDetails.auditId
        }
        let Api = isTitleInventory ? '/tms/api/v1/inventory/getNotesByVehicleId': '/lender/api/v1/lender/getNotesByType'
        return callAPI.get( Api, req).then(
            (response) => {
                if (response.status === 200) {
                    dispatch(setSharedNotes(
                        {
                            dealerId: id,
                            counts: response.data && response.data.notesData && response.data.notesData.count ? response.data.notesData.count : {},
                            notesData: {
                                [notesType]: response.data && response.data.notesData ? response.data.notesData : []
                            }
                        }
                    ))
                    dispatch(setSharedNotesLoader(false));
                    return response.data;
                } else {
                    dispatch(setSharedNotes({
                        counts: {
                            dealerNotesCount: 0,
                            vehicleNotesCount: 0,
                            titleNotesCount: 0,
                            auditNotesCount: 0,
                            paymentNotesCount: 0
                        },
                        notesData: {

                        }
                    }))
                    dispatch(setSharedNotesLoader(false));
                }
            }
        )
    }
}